import baseMixin from "../baseMixin";
// import Marquee from '../Marquee/Marquee.vue'
import FixedItem from "./FixedItem/FixedItem.vue";
import Module from '@/components/base/Module/Module.vue';
// import ShakeEgg from '../ShakeEgg/ShakeEgg.vue'
import EggAd from '@/page/index/components/EggAd/EggAd';
export default {
  mixins: [baseMixin],
  data: function data() {
    return {
      picSize: '100x100',
      red: false
    };
  },
  computed: {
    currentSetting: function currentSetting() {
      if (this.$store.state.indexPageModule.serverSetting && this.$store.state.indexPageModule.serverSetting['碰蛋入口']) {
        return this.$store.state.indexPageModule.serverSetting['碰蛋入口'];
      }
      return null;
    },
    showList: function showList() {
      // 计算每行的展示数量
      var enums = {
        vft_regular: 5,
        // 普通屏幕
        vft_large: 6,
        // 折叠屏
        vft_huge: 8,
        // ipad
        vft_max: 10 // ipad pro
      };

      var size = enums[this.deviceSize];
      return this.list.slice(0, size);
    },
    reportParams: function reportParams() {
      return {
        f_module: '固定入口',
        f_module_id: this.id,
        eid: 'module'
      };
    }
  },
  settingKey: '碰蛋入口',
  setting: {
    开启福利社摇蛋: false,
    开启广告位: false
  },
  components: {
    EggAd: EggAd,
    // ShakeEgg,
    Module: Module,
    // Marquee,
    FixedItem: FixedItem
  },
  ptag: 'xrk'
};